import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

/**
 * Resolves the human-readable display names for a batch of shareables of one
 * type. Used by the shareables browser for types whose backend graph node
 * carries no meaningful name (it falls back to "Unbekannte Ressource …"), but
 * whose real name lives on the underlying resource — e.g. a Klia attachment's
 * file name, fetched from `GET /klia-attachments/{id}`.
 *
 * Returns a map keyed by id → name. Best-effort and batched by contract, not by
 * transport: an implementation without a batch endpoint fans the ids out itself
 * (bounded concurrency, failures tolerated). Ids missing from the returned map
 * simply keep the backend-provided name — the caller treats them as resolved
 * and does not ask again, so an implementation must never fail the whole batch
 * over one unresolvable id.
 */
export type ShareableNameResolver = (
  ids: readonly string[],
) => Observable<ReadonlyMap<string, string>>;

export type ShareableNameResolvers = ReadonlyMap<
  ShareableType,
  ShareableNameResolver
>;

export const BD_SHAREABLE_NAME_RESOLVERS =
  new InjectionToken<ShareableNameResolvers>('BD_SHAREABLE_NAME_RESOLVERS');
